import { QueryBuilderReactPlugin } from '@sierralabs/query-ui';

export const TaskDisplayVersionQueryBuilderPlugin: QueryBuilderReactPlugin = {
  name: 'Task Display Version',
  type: 'TaskDisplayVersion',
  columns: [
    {
      name: 'Display Version',
      selection: 'task_display_version',
      type: 'text'
    },
    {
      name: 'Display Version (v2)',
      selection: 'task_v2_display_version',
      type: 'text'
    }
  ]
};
